import Vue from 'vue'
import Router from 'vue-router'

import About from '@/views/About.vue'
import Developments from '@/views/Developments'
import LocalInformation from '@/views/LocalInformation'
import Development from '@/views/Development.vue'

import Property from '@/views/Property'
import PropertyIntro from '@/views/property/Intro'
import PropertyFloorplans from '@/views/property/Floorplans'
import PropertySpecifications from '@/views/property/Specifications'
import PropertyPurchaseOptions from '@/views/property/PurchaseOptions'

import AboutLaurusHomes from '@/views/about/LaurusHomes.vue'
import AboutBuyingProcess from '@/views/about/BuyingProcess.vue'
import AboutTestimonials from '@/views/about/Testimonials.vue'
import AboutPurchaseOptions from '@/views/about/PurchaseOptions'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'developments',
      props: true,
      component: Developments
    },
    {
      path: '/developments/:id',
      name: 'development',
      component: Development
    },
    {
      path: '/developments/:id/local-information',
      name: 'local-information',
      component: LocalInformation
    },
    {
      path: '/developments/:development/:plot',
      component: Property,
      children: [
        {
          path: '',
          name: 'property-intro',
          component: PropertyIntro
        },
        {
          path: 'floorplans',
          name: 'property-floorplans',
          component: PropertyFloorplans
        },
        {
          path: 'specifications',
          name: 'property-specifications',
          component: PropertySpecifications
        },
        {
          path: 'purchase-options',
          name: 'property-purchase-options',
          component: PropertyPurchaseOptions
        }
      ]
    },
    {
      path: '/developments/:id/about',
      component: About,
      children: [
        {
          path: 'company',
          name: 'about-company',
          component: AboutLaurusHomes
        },
        {
          path: 'options',
          name: 'about-purchase-options',
          component: AboutPurchaseOptions
        },
        {
          path: 'buying-process',
          name: 'about-buying-process',
          component: AboutBuyingProcess
        },
        {
          path: 'testimonials',
          name: 'about-testimonials',
          component: AboutTestimonials
        }
      ]
    }
  ]
})
